import { Icon } from "@chakra-ui/react";
import React from "react";

export const UserIcon = () => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    size="sm"
  >
    <path
      d="M8 1.33325C6.162 1.33325 4.66667 2.82859 4.66667 4.66659C4.66667 6.50459 6.162 7.99992 8 7.99992C9.838 7.99992 11.3333 6.50459 11.3333 4.66659C11.3333 2.82859 9.838 1.33325 8 1.33325ZM8 6.66659C6.89733 6.66659 6 5.76925 6 4.66659C6 3.56392 6.89733 2.66659 8 2.66659C9.10267 2.66659 10 3.56392 10 4.66659C10 5.76925 9.10267 6.66659 8 6.66659ZM14 13.9999V13.3333C14 10.7606 11.906 8.66659 9.33333 8.66659H6.66667C4.09333 8.66659 2 10.7606 2 13.3333V13.9999H3.33333V13.3333C3.33333 11.4953 4.82867 9.99992 6.66667 9.99992H9.33333C11.1713 9.99992 12.6667 11.4953 12.6667 13.3333V13.9999H14Z"
      fill="#424360"
    />
  </Icon>
);
